// extracted by mini-css-extract-plugin
export default {"stack":"NotificationToasts_stack__acs3R","toast":"NotificationToasts_toast__tTq84","body":"NotificationToasts_body__ArIJv"};